import { useMutation, useQueryClient } from "@tanstack/react-query";
import { t } from "ttag";

import { updatePatientLanguagePreference } from "@/app/api/legacy-api";
import { LanguageSwitch } from "@/shared/components";
import { AVAILABLE_LANGUAGE } from "@/shared/models";
import { errorToast, Header } from "@/shared/ui";
import { EditProfileButton } from "../components";

export const ProfileOverviewHeader = () => {
  const queryClient = useQueryClient();
  const { mutate: updatePatientLanguagePreferenceMutation, isPending } =
    useMutation({
      mutationFn: updatePatientLanguagePreference.mutation,
      onSuccess: () => {
        updatePatientLanguagePreference.invalidates(queryClient);
      },
      onError: errorToast,
    });

  return (
    <Header.Root>
      <Header.Content className="flex-row items-center justify-between">
        <Header.Title>{t`My profile`}</Header.Title>

        <Header.Actions className="gap-2">
          <LanguageSwitch
            disabled={isPending}
            onCheckedChange={(checked) =>
              updatePatientLanguagePreferenceMutation(
                checked ? AVAILABLE_LANGUAGE.ES : AVAILABLE_LANGUAGE.EN,
              )
            }
          />
          <EditProfileButton position="header" />
        </Header.Actions>
      </Header.Content>
    </Header.Root>
  );
};
